<template>
  <CommonPages id="services" classs="services-page" titlePrefix="Services - Velocifyx"
    metaDescription="Connect with the right audience through our seamless, transparent ad trading platform. Access premium inventory, optimize campaigns in real time, and leverage expert support to drive measurable growth for your brand.">
    <div class="page-header"></div>
    <section class="services-section">
      <div class="services-section__header">
        <h2 class="services-section__title">Services We Provide</h2>
        <p class="services-section__subtitle">
          We offer high-quality advertising solutions designed to help brands expand reach, optimize campaigns, and maximize return on investment.
        </p>
      </div>
      <div class="services-section__grid">
        <div class="service-card" v-for="(service, index) in services" :key="index">
          <img :src="service.image" :alt="service.title" class="service-card__image">
          <div class="service-card__content">
            <h3 class="service-card__title">{{ service.title }}</h3>
            <p class="service-card__description">{{ service.description }}</p>
          </div>
        </div>
      </div>
    </section>
    <section class="how-it-works-section">
      <div class="how-it-works-section__header">
        <h2 class="how-it-works-section__title">How dose it work ?</h2>
      </div>
      <div class="how-it-works-section__grid">
        <div class="work-step" v-for="(step, index) in workSteps" :key="index">
          <div class="work-step__icon-container">
            <img :src="step.icon" :alt="step.title" class="work-step__icon">
          </div>
          <div class="work-step__content">
            <h3 class="work-step__title">{{ step.title }}</h3>
            <p class="work-step__description">{{ step.description }}</p>
          </div>
        </div>
      </div>
    </section>
  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue';
import '@/css/services.scss';

export default {
  name: 'Services',
  components: {
    CommonPages,
  },
  data () {
    return {
      services: [
        {
          title: 'Targeted Audience Reach',
          description: 'Precisely connect your brand with the right audience across multiple platforms.',
          image: require('@/assets/service-1.png')
        },
        {
          title: 'Real-Time Premium Inventory Access',
          description: ' Continuously monitor and adjust campaigns to maximize performance and ROI.',
          image: require('@/assets/service-2.png')
        },
        {
          title: 'Premium Inventory Access',
          description: 'Gain exclusive access to high-quality ad spaces that drive impactful results.',
          image: require('@/assets/service-3.png')
        },
        {
          title: 'Data-Driven Insights',
          description: 'Leverage actionable analytics to inform strategies and improve campaign outcomes.',
          image: require('@/assets/service-4.png')
        }
      ],
      workSteps: [
        {
          title: 'Create Your Account',
          description: 'Get started by registering and verifying your profile to unlock platform access.',
          icon: require('@/assets/connect-1.svg')
        },
        {
          title: 'Integrate Your Platforms',
          description: 'Connect your advertising accounts for seamless campaign management across networks.',
          icon: require('@/assets/connect-2.svg')
        },
        {
          title: 'Discover Inventory Options',
          description: 'Browse premium ad spaces and select placements tailored to your campaign objectives.',
          icon: require('@/assets/connect-3.svg')
        },
        {
          title: 'Bid and Acquire',
          description: 'Engage in real-time auctions to secure high-quality ad inventory efficiently.',
          icon: require('@/assets/connect-4.svg')
        },
        {
          title: 'Launch and Track',
          description: 'Deploy campaigns and monitor performance using live analytics and actionable insights.',
          icon: require('@/assets/connect-5.svg')
        },
        {
          title: 'Refine and Expand',
          description: 'Continuously optimize campaigns with data-driven strategies and expert guidance to scale results.',
          icon: require('@/assets/connect-6.svg')
        }
      ]
    };
  }
};
</script>
